export default __webpack_public_path__ + "static/media/velo.d516c0e8.svg";